import { ref, watch } from 'vue'

export function useLocalStorage(key, initialValue = null) {
  const storedValue = localStorage.getItem(key)
  let data;
  try {
    const json_store_value = JSON.parse(storedValue)
    data = ref(storedValue ? json_store_value : initialValue)
  } catch (e){
    console.log(e.Message)
    data = ref(initialValue)
  } 
  
  // Actualiza localStorage cuando cambia el ref
  watch(data, (newVal) => {
    localStorage.setItem(key, JSON.stringify(newVal))
    window.dispatchEvent(new CustomEvent('localstorage-changed', { detail: { key, value: newVal } }))
  }, { deep: true })

  // Escucha cambios en otras pestañas
  window.addEventListener('storage', (event) => {
    if (event.key === key) {
      try {
        data.value = event.newValue ? JSON.parse(event.newValue) : null
      } catch {
        data.value = null
      }
    }
  })

  // Escucha cambios emitidos en esta pestaña
  window.addEventListener('localstorage-changed', (event) => {
    if (event.detail.key === key) {
      data.value = event.detail.value
    }
  })

  return data
}
